import * as React from 'react';
import { Theme } from '@mui/styles';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Button} from '@mui/material';
import { Typography } from '@mui/material';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {Grid} from '@mui/material';
import {StringAttribute} from '../../../common/lib/types'

type State = {
   open: boolean;
//    confirmData: confirmForm;
};

interface Props extends React.HTMLProps<HTMLDivElement> {
   classes: any;
   open: boolean;
   title: string;
   confirmMessage: string;
   handleYes: ()=>void
   handleNo: ()=>void
  }

  const styles = (theme:Theme):StyleRules => ({
    modalContent: {
        width: 500
    },
    actionAutoConfirmButtonClass:{
        border: 'dashed 1px #dedede'
    },
    modalTitle: {
        padding: "0px 0px 20px 0px"
    },
    gridItem: {
        paddingBottom: "0px !important;",
        paddingTop: "0px !important;"
    },
    controlContainer: {
        width: "100%",
        padding: 0
    },
    dangerButton: {
        backgroundColor: "#af0202",
        '&:hover': {
            backgroundColor: "#5D0A0A !important"
        }
    }
})

class ConfirmYesNo extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {
            open: props.open,
            // confirmData: new confirmForm({})
        }
      }

   componentDidMount() {
        // Mousetrap is a window object so reset it.  handleClose will rebind the hot-keysç
        Mousetrap.reset()
        Mousetrap.bind("alt+n", this.handleClose)
        Mousetrap.bind("alt+y", this.handleDispatch)
    
    }
    componentWillUnmount() {
        
    }

    onConfirmDataChange = (f: any): any => (event: any): void => {
        if (f.handleChange) {
            f.handleChange(event)
            this.setState({});
        }
    }

    handleDispatch = () => {
        
        this.props.handleYes()
    }

  
    closeDialog = () => {
        this.handleClose({}, "")
    }

    handleClose = (event, reason) => {
        Mousetrap.reset()
        if (reason !== 'backdropClick') {
            this.props.handleNo()
        }
    }

    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;
        const {open} = this.state
        
        return (
            <Dialog
                className={classes.modal}
                open={open}
                onClose={this.handleClose}
            >   
                <DialogContent className={classes.modalContent}>
                    <DialogTitle className={classes.modalTitle}>
                        {this.props.title}
                    </DialogTitle>  
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Typography dangerouslySetInnerHTML={{ __html: this.props.confirmMessage}} variant="subtitle1"></Typography> 
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="contained"
                        color="inherit"
                        onClick={this.closeDialog}>
                        <u>N</u>o
                    </Button>
                    <Button 
                        autoFocus={true}
                        variant="contained"
                        color="primary"
                        className={classes.actionAutoConfirmButtonClass} 
                        onClick={this.handleDispatch}>
                        <u>Y</u>es
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(ConfirmYesNo);